import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Stack,
  Button,
  SimpleGrid,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import StudioImage from "./images/studio1.png";
import HeroImage from "./images/stamps.png";

const StudioDescription = () => {
  const navigate = useNavigate();

  return (
    <Box>
      <Navbar />

      {/* Background image */}
      <Image
        src={HeroImage}
        alt="Hero Watermark"
        width="100%"
        height="100%"
        objectFit="cover"
        opacity={0.30}
        position="absolute"
        top={0}
        left={0}
        zIndex={-1}
        filter="blur(1px)"
      />

      <Container maxW="container.xl" py={8}>
        <Stack spacing={8} align="stretch">
          {/* Header Section */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={12}
            borderRadius="lg"
            boxShadow="xl"
            textAlign="center"
          >
            <Image
              src={StudioImage}
              alt="Studio"
              maxW="400px"
              mx="auto"
              mb={6}
            />
          </Box>

          {/* Key Features */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800" textAlign="center">
              Key Features
            </Heading>

            <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={6}>
              <Box p={4} bg="blue.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Natural contract authoring experience
                </Text>
              </Box>

              <Box p={4} bg="blue.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Automated information capture
                </Text>
              </Box>

              <Box p={4} bg="blue.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Integrated placement workflow
                </Text>
              </Box>

              <Box p={4} bg="blue.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Collaborative editing capabilities
                </Text>
              </Box>

              <Box p={4} bg="blue.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Template-driven efficiency
                </Text>
              </Box>

              <Box p={4} bg="blue.50" borderRadius="md" boxShadow="md">
                <Text color="gray.700" fontSize="md">
                  Granular access controls
                </Text>
              </Box>
            </SimpleGrid>
          </Box>

          {/* Main Content */}
          <Box
            bg="rgba(255,255,255,0.95)"
            p={10}
            borderRadius="lg"
            boxShadow="xl"
          >
            <Heading size="lg" mb={6} color="gray.800">
              USE CASE #1: "Write Contracts the old way..."
            </Heading>

            <Text fontSize="lg" mb={6} lineHeight="1.8" color="gray.700">
              Streamline contract creation with flexible templates and collaborative workflows that enhance efficiency across your organization.
            </Text>

            <SimpleGrid columns={{ base: 1, md: 2 }} spacing={8} mb={8}>
              <Box>
                <Heading size="lg" color="blue.600" mb={4}>
                  BENEFIT
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Back To Basics Editing
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Intuitive contract creation that captures information naturally as you work.
                    </Text>
                  </Box>

                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Streamlined Placing Workflow
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Collaborate seamlessly within a unified environment.
                    </Text>
                  </Box>

                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Higher Quality Contracts
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Enhanced control and consistency through managed access and standardized content.
                    </Text>
                  </Box>

                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Write More Business
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Faster throughput.
                    </Text>
                  </Box>
                </Stack>
              </Box>

              <Box>
                <Heading size="lg" color="blue.600" mb={4}>
                  FEATURES
                </Heading>
                <Stack spacing={4}>
                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Standard Editing Functionality
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Format your contract without leaving the page.
                    </Text>
                  </Box>

                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Industry Standards
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Built on recognized industry frameworks and best practices.
                    </Text>
                  </Box>

                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      More data for less work
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Efficient template management that adapts to evolving requirements while maintaining consistency.
                    </Text>
                  </Box>

                  <Box p={4} bg="blue.50" borderRadius="md">
                    <Heading size="sm" color="gray.800" mb={2}>
                      Better Quality Jobs
                    </Heading>
                    <Text color="gray.700" fontSize="sm">
                      Reduce manual effort and elevate your team to focus on quality oversight.
                    </Text>
                  </Box>
                </Stack>
              </Box>
            </SimpleGrid>

            <Box textAlign="center" mt={8}>
              <Button
                colorScheme="blue"
                size="lg"
                onClick={() => navigate("/studio")}
                boxShadow="lg"
                _hover={{ transform: "scale(1.05)" }}
                transition="all 0.2s"
              >
                Launch Studio
              </Button>
            </Box>
          </Box>

          
        </Stack>
      </Container>
    </Box>
  );
};

export default StudioDescription;
